import { ReactElement, useEffect } from 'react';
import Home from './pages/Home';

function App(): ReactElement {
  useEffect(() => {
    // Only load HubSpot tracking in production
    if (process.env.NODE_ENV === 'production') {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = 'hs-script-loader';
      script.async = true;
      script.defer = true;
      script.src = '//js-na2.hs-scripts.com/244614323.js';

      document.body.appendChild(script);

      // Cleanup function to remove script if component unmounts
      return () => {
        const existingScript = document.getElementById('hs-script-loader');
        if (existingScript) {
          existingScript.remove();
        }
      };
    }
  }, []);

  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
